// PosOrdersSheet.tsx — Feuille « Commandes » (mode restauration)
// À déposer dans : src/gestion-pos/PosOrdersSheet.tsx
// Reproduit la maquette : liste des commandes restaurant à traiter (table/source,
// articles, total, statut, ancienneté). Alimentée par props — branche `orders` sur
// la même source que ton drawer restaurant (handleOpenRestaurantOrdersPanel).
import React from "react";
import { Icon, fmt, ORDER_STATUS_META, PosOrder } from "./posMobileShared";

export interface PosOrdersSheetProps {
  onClose: () => void;
  orders: PosOrder[];
  badge?: number;
  onSelectOrder?: (order: PosOrder) => void;
}

export default function PosOrdersSheet({ onClose, orders, badge, onSelectOrder }: PosOrdersSheetProps) {
  const toTreat = badge ?? orders.filter((o) => o.status !== "kitchen").length;
  return (
    <>
      <div className="pos-scrim" onClick={onClose} />
      <div className="pos-sheet">
        <div className="pos-grab" />
        <div className="pos-sheet-head">
          <div className="pos-sheet-title">Commandes<span className="n">{toTreat} à traiter</span></div>
          <button className="pos-sheet-close" onClick={onClose}><Icon name="x" size={18} stroke={2.2} /></button>
        </div>
        <div className="pos-sheet-body" style={{ paddingBottom: 26 }}>
          {orders.length === 0 ? (
            <div className="pos-empty">
              <div className="pos-empty-ico"><Icon name="receipt" size={30} stroke={1.6} /></div>
              <div className="pos-empty-t">Aucune commande</div>
              <div className="pos-empty-s">Les commandes en cours apparaîtront ici.</div>
            </div>
          ) : orders.map((o) => {
            const st = ORDER_STATUS_META[o.status];
            return (
              <button className="pos-order" key={o.ref} style={{ width: "100%", textAlign: "left" }}
                onClick={() => onSelectOrder && onSelectOrder(o)}>
                <div className="pos-order-ico"><Icon name="receipt" size={20} stroke={1.7} /></div>
                <div className="pos-order-mid">
                  <div className="pos-order-top">
                    <span className="pos-order-place">{o.place}</span>
                    {st && <span className={"rf-pill rf-pill-sm " + st.cls}><span className="rf-pill-dot" />{st.label}</span>}
                  </div>
                  <div className="pos-order-meta">
                    {o.ref}<span className="sep">·</span>{o.source}<span className="sep">·</span>{o.items} articles
                  </div>
                </div>
                <div className="pos-order-right">
                  <div className="pos-order-total">{fmt(o.total)} F</div>
                  <div className="pos-order-time"><Icon name="clock" size={12} stroke={2} />il y a {o.mins} min</div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
}
